/* eslint-disable */
window.setYDUIStyle = function (param) {
    if(window.dispatchEvent) {  
      window.dispatchEvent(
        new CustomEvent('YDUIStyleChange', {
          detail: param
        })
      );
    } else {
      window.fireEvent(
        new CustomEvent('YDUIStyleChange', {
          detail: param
        })
      );
    }
  }
  
